import React from 'react';
import styled from 'styled-components';
import {BarLoader} from 'react-spinners';
import theme from '../../constants/theme';

const LoadingWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const Bar = styled(BarLoader)`
  height: 10px;
`;

const Loading = () => (
  <LoadingWrapper>
    <Bar color={theme.primaryColor} />
  </LoadingWrapper>
);

export default Loading;
